<template>
  <v-dialog :value="value" @input="handleDialogInput" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        {{ routemap.name }} {{ routemap.quantity }} {{ $t("COUNT_ABBREVIATION") }}
      </v-card-title>

      <v-card-text>
        <ErrorMessages :errorMessages="localErrorMessages" />

        {{ $t("COMMENT") }} (BG):
        <textarea v-model="comment" class="form-control"></textarea>
        <br />
        {{ $t("COMMENT") }} (EN):
        <textarea v-model="commentEn" class="form-control"></textarea>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text>
          <span class="btn btn-success btn-block" @click="handleStartClicked">
            {{ $t("START") }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ErrorMessages from "@/components/ErrorMessages";

export default {
  components: {
    ErrorMessages,
  },

  props: {
    routemap: {
      required: true,
      type: Object,
    },

    value: {
      required: true,
      type: Boolean,
    },

    errorMessages: {
      default: () => {},
    },
  },

  data() {
    return {
      comment: "",
      commentEn: "",
      localErrorMessages: {},
    };
  },

  watch: {
    value() {
      this.comment = "";
      this.commentEn = "";
      this.localErrorMessages = {};
    },

    errorMessages() {
      this.localErrorMessages = this.errorMessages;
    },
  },

  methods: {
    handleStartClicked() {
      if (!this.comment || !this.commentEn) {
        this.localErrorMessages = {
          0: [this.$t("THE_FIELD_COMMENT_IS_REQUIRED")],
        };

        return;
      }

      this.$emit("start-clicked", {
        comment: this.comment,
        commentEn: this.commentEn,
      });
    },

    handleDialogInput(value) {
      this.comment = "";
      this.commentEn = "";
      this.localErrorMessages = {};

      this.$emit("input", value);
    },
  },
};
</script>
